import _ from "lodash";

const TYPECODE = {
    TEST: 'test',
    NOTES: 'studyNotes',
    FORMULA: 'formula',
    VIDEO: 'video',
}
export const handleContentSelect = (content: any, length: number, handleSetState: Function) => {
    if (content.length > 0 || length) {
        handleSetState({
            selectedQuestionCount: length
        });
    } else {
        handleSetState({
            selectedQuestionCount: 0
        });
    }
    handleSetState({ tempQuestions: content });
};

const compareConceptAndChapter = (mappedConceptsAndChapter: any, getContentsMapping: any, treeData: any) => {
    const totalDataOfContentsMapping = getContentsMapping.size;
    let data: any = [];
    let keyIterator = getContentsMapping.keys();
    // let valueIterator = getContentMapping.
    for (let i = 0; i < totalDataOfContentsMapping; i++) {
        const ids = keyIterator.next().value;
        const indexes = mappedConceptsAndChapter.get(ids);
        if (indexes) {
            const content = getContentsMapping.get(ids);

            data.push({ indexes: mappedConceptsAndChapter.get(ids), content })
        }
    }
    return data;
}
export const handleAddContent = ({ contents, treeData, setTreeData, mappedConceptsAndChapter,level,conceptPhaseData,bonusContent, bonusCriteria}: any, handleSelectedFilterQuestion: Function) => {
    const getContentsMapping = getContent(contents, treeData,level);
    const compareData = compareConceptAndChapter(mappedConceptsAndChapter, getContentsMapping, treeData);
    // const compareData = compareConceptAndChapterDataWithContentData(getContentsMapping, mappedConceptsAndChapter);
    compareData && compareData.length && setTreeContentData({ treeData, setTreeData, compareData ,conceptPhaseData,bonusContent, bonusCriteria}, handleSelectedFilterQuestion);
    handleSelectedFilterQuestion(contents);
}
const setTreeContentData = ({ treeData, setTreeData, compareData,conceptPhaseData,bonusContent, bonusCriteria}: any, handleSelectedFilterQuestion: Function) => {
    if (compareData && compareData.length) {
        const { phases = [],displaySettings } = treeData;
        let clonePhases = JSON.parse(JSON.stringify(phases));
        let contentData: any = [];
        const levels=["phase","week","chapter","concept"];
        const indexNames=['phaseIndex', 'weekIndex','chapterIndex', 'conceptIndex'];
        
        compareData.forEach((element: any) => {
            
            if(conceptPhaseData && !_.isEmpty(conceptPhaseData)){
                let currLvl=levels.indexOf(conceptPhaseData.key);
                
                while(currLvl>=0){
                    let keyName=indexNames[currLvl];
                    if(element.indexes[keyName]!=conceptPhaseData[keyName]){
                      return ;
                    }
                    currLvl--;
                }    
            }
            if (element && element.indexes.hasOwnProperty('conceptIndex')) {
                const { indexes: { phaseIndex, weekIndex, subjectIndex, chapterIndex, conceptIndex }, content } = element;
                let courseId = clonePhases[phaseIndex]['weeks']
                [weekIndex]['subjects']
                [subjectIndex]['chapters']
                [chapterIndex]['concepts']
                [conceptIndex].courseSyllabusIds[0].courseId;
                const contentObject = getContentForTreeData(content,courseId,bonusContent, bonusCriteria)
                clonePhases[phaseIndex]['weeks']
                [weekIndex]['subjects']
                [subjectIndex]['chapters']
                [chapterIndex]['concepts']
                [conceptIndex]['content'] = [...clonePhases[phaseIndex]['weeks']
                [weekIndex]['subjects']
                [subjectIndex]['chapters']
                [chapterIndex]['concepts']
                [conceptIndex]['content'], ...contentObject];
                // contentData.push(contentObject);
                const clonePhasesWithBulkKey =
                    setIsBulkAdded(clonePhases, phaseIndex, weekIndex, subjectIndex, chapterIndex, conceptIndex);
                clonePhases = JSON.parse(JSON.stringify(clonePhasesWithBulkKey));
            } else {
                const { indexes: { phaseIndex, weekIndex, subjectIndex, chapterIndex, conceptIndex }, content } = element;
                let courseId = clonePhases[phaseIndex]['weeks']
                [weekIndex]['subjects']
                [subjectIndex]['chapters']
                [chapterIndex].courseSyllabusIds[0].courseId
                const contentObject = getContentForTreeData(content, courseId,bonusContent,bonusCriteria)
                clonePhases[phaseIndex]['weeks']
                [weekIndex]['subjects']
                [subjectIndex]['chapters']
                [chapterIndex]['content'] = [...clonePhases[phaseIndex]['weeks']
                [weekIndex]['subjects']
                [subjectIndex]['chapters']
                [chapterIndex]['content'], ...contentObject];
                // contentData.push(contentObject);
                const clonePhasesWithBulkKey =
                    setIsBulkAdded(clonePhases, phaseIndex, weekIndex, subjectIndex, chapterIndex, conceptIndex);
                clonePhases = JSON.parse(JSON.stringify(clonePhasesWithBulkKey));
            }
        });
        // handleSelectedFilterQuestion(contentData);
        setTreeData({
            treeData: { ...treeData, phases: [...JSON.parse(JSON.stringify(clonePhases))] }
        })
    }
};

const getContentType = (type: string) => {
    switch (type) {
        case 'note':
            return TYPECODE.NOTES;
        case 'videos':
            return TYPECODE.VIDEO;
        case 'formulas':
            return TYPECODE.FORMULA;
        case 'testpapers':
            return TYPECODE.TEST;
    }
}
const getContentForTreeData = (contents: any, courseId: string,bonusContent:boolean, bonusCriteria:any) => {
    let contentData: any = [];
    console.log({ contents });
    contents && contents.forEach((content: any) => {
        let contentObject: any = {};
        if (content.contentTypeCode === 'testpapers') {
            contentObject = {
                id: content.content_Id,
                type: getContentType(content.contentTypeCode),
                title: content.title,
                description: "",
                isBonus: false,
                contentId: content.contentId,
                testDetails: {
                    testId: content.content_Id,
                    scheduleID: "",
                    name: content.title,
                    courseId: courseId,
                    syllabus: "Concept will be covered",
                    "startDate": null,
                    "endDate": null,
                    "revisionTime": 0,
                    "type": content.contentSubTypeCode,
                    "duration": content.duration || 180
                },
                isBulkDataAdded: true,
            }
        } else {
            contentObject = {
                id: content.content_Id,
                type: getContentType(content.contentSubTypeCode),
                title: content.title,
                description: "",
                isBonus: false,
                contentId: content.contentId,
                isBulkDataAdded: true,
            }
        }
        if(bonusContent){
            contentObject={...contentObject,isBonus:true,bonusCriteria};
        }
        contentData.push(contentObject);
    });
    return contentData;
};

const getContent = (contents: any, treeData: any,level:string='') => {
    // let maintainChapterAndConcept: any = new Map();
    // contents.forEach((content: any) => {
    //     const { subjects = [] } = content;
    let getContentMapping = contentMappingWithHash(contents, treeData,level);

    // });
    return getContentMapping;

}
const contentMapping = (subjects: any, content: any) => {
    let chapterMapping: any = [];
    let conceptMapping: any = [];
    subjects.forEach((subject: any) => {
        const { subSubjects = [], subjectId } = subject;
        subjectId && subSubjects.forEach((subSubject: any) => {
            const { chapters = [] } = subSubject;
            chapters.forEach((chapter: any) => {
                const { concepts = [], checked, chapterId } = chapter;
                // if (checked) {
                let chapterMapped = {
                    masterId: chapterId && chapterId._id
                }
                chapterMapping.push(chapterMapped);
                // }
                concepts.forEach((concepts: any) => {
                    const { checked, conceptId } = concepts;
                    // if (checked) {
                    let conceptMapped = {
                        masterId: conceptId && conceptId._id
                    }
                    conceptMapping.push(conceptMapped)
                    // }
                });
            });
        });

    });
    return { chapterMapping, conceptMapping, content };
}

const getIds = (treeData: any, content_Id: any) => {
    let id: any = [];
    const { phases = [] } = treeData;
    phases.forEach((phase: any, phaseIndex: number) => {
        const { weeks = [] } = phase;
        weeks.forEach((week: any, weekIndex: number) => {
            const { subjects = [] } = week;
            subjects.forEach((subject: any, subjectIndex: number) => {
                const { chapters = [] } = subject;
                chapters.forEach((chapter: any, chapterIndex: number) => {
                    const { concepts = [], content = [] } = chapter;
                    const findIds = content.filter((ele: any) => ele.content_Id === content_Id || ele.id === content_Id)
                    const allIdsAttachedToContent = findIds.map((ele: any) => ele.id);
                    if (allIdsAttachedToContent && allIdsAttachedToContent.length) {
                        id = [...id, allIdsAttachedToContent];
                    }
                    concepts.forEach((concept: any, conceptIndex: number) => {
                        const { content = [] } = concept;
                        const findIdsOfConcept = content.filter((ele: any) => ele.content_Id === content_Id || ele.id === content_Id)
                        const allIdsAttachedToConceptContent = findIdsOfConcept.map((ele: any) => ele.id);
                        if (allIdsAttachedToConceptContent && allIdsAttachedToConceptContent.length) {
                            id = [...id, allIdsAttachedToConceptContent];
                        }
                    })
                })
            })
        });
    });
    return id;
}
const contentMappingWithHash = (contents: any, treeData: any,level?:string) => {
    let allMapping: any = new Map();
    let chapterData: any = {};
    let conceptData: any = {};
    contents.forEach((content: any) => {
        const { subjects = [], contentTypeCode = '', contentSubTypeCode = '' } = content;
        if (content.hasOwnProperty('subjects')) {
            subjects.forEach((subject: any) => {
                const { subSubjects = [], subjectId } = subject;
                subjectId && subSubjects.forEach((subSubject: any) => {
                    const { chapters = [] } = subSubject;
                    chapters.forEach((chapter: any) => {
                        const { concepts = [], checked, chapterId } = chapter;

                        // if (checked) {
                        // contentTypeCode === 'testpapers'
                        //     && contentSubTypeCode === 'chap' &&
                            // allMapping.set(chapterId && chapterId._id, content);
                          if(level=='chapter'){
                             if(contentTypeCode !=='testpapers'||(contentTypeCode === 'testpapers'&& contentSubTypeCode === 'chap')){   
                                chapterId && chapterId._id && (chapterData[chapterId._id] = chapterData[chapterId._id] ? [...chapterData[chapterId._id], content] : [content]);
                             }
                          }
                            // }
                        else{    
                        concepts.forEach((concepts: any) => {
                            const { checked, conceptId } = concepts;
                            // if (checked) {
                            contentSubTypeCode !== 'chap' &&
                                // allMapping.set(conceptId && conceptId._id, content)
                                conceptId && conceptId._id && (conceptData[conceptId._id] = conceptData[conceptId._id] ? [...conceptData[conceptId._id], content] : [content]);
                            // }
                        });
                      } 
                    });
                });
            });
        }
        else {
            const { type, id } = content;
            const allIds = getIds(treeData, id);
            allIds.forEach((ids: any) => {
                if (type === 'video' || type === 'studyNotes' || type === 'formulas') {
                    if(level==='chapter'){
                        ids && (chapterData[ids] = chapterData[ids] ? [...chapterData[ids], content] : [content]);
                    }else{
                      ids && (conceptData[ids] = conceptData[ids] ? [...conceptData[ids], content] : [content]);
                    }
                } else {
                    if (content && content.testDetails && Object.keys(content.testDetails).length) {
                        const { type = '' } = content.testDetails;
                        if (type === 'chap'&&level==='chapter'){
                            ids && (chapterData[ids] = chapterData[ids] ? [...chapterData[ids], content] : [content]);
                        } else if(level==='concept'){
                            ids && (conceptData[ids] = conceptData[ids] ? [...conceptData[ids], content] : [content]);
                        }
                    }
                }

            })

        }
    })
    Object.keys(chapterData).forEach((key: any) => {
        allMapping.set(`${key}`, chapterData[key]);
    });
    Object.keys(conceptData).forEach((key: any) => {
        allMapping.set(`${key}`, conceptData[key]);
    })
    console.log({ chapterData, conceptData });
    return allMapping;
}

const compareConceptAndChapterDataWithContentData = (conceptsAndChapter: any, mappedConceptAndChapter: any) => {
    let getIndexOfContentsAndChapter: any = [];

    conceptsAndChapter.forEach((element: any) => {
        const { chapterMapping = [], conceptMapping = [], content } = element;
        chapterMapping
            && chapterMapping.length &&
            chapterMapping.forEach((chapter: any) => {
                const { chapterAddress = [] } = mappedConceptAndChapter;
                chapterAddress
                    && chapterAddress.length
                    && chapterAddress.forEach((mappedChapter: any) => {
                        if (chapter.masterId === mappedChapter.masterId) {
                            getIndexOfContentsAndChapter.push({ ...mappedChapter, content });
                        }
                    });
            });

        conceptMapping &&
            conceptMapping.length &&
            conceptMapping.forEach((concept: any) => {
                const { conceptAddress = [] } = mappedConceptAndChapter;
                conceptAddress
                    && conceptAddress.length
                    && conceptAddress.forEach((mappedConcept: any) => {

                        if (concept.masterId === mappedConcept.masterId) {
                            getIndexOfContentsAndChapter.push({ ...mappedConcept, content });
                        }
                    });
            });
    });
    return getIndexOfContentsAndChapter;
}

const checkIfIndexIsValid = (index: any) => {
    if (typeof index === 'undefined') {
        return false;
    } else if (index > -1) {
        return true
    }
}
const setIsBulkAdded = (clonePhases: any, phaseIndex: number,
    weekIndex: number, subjectIndex: number, chapterIndex: number,
    conceptIndex: number) => {
    console.log({ conceptIndex, chapterIndex, subjectIndex });
    checkIfIndexIsValid(phaseIndex)
        && (clonePhases[phaseIndex].isBulkDataAdded = true);

    checkIfIndexIsValid(phaseIndex)
        && checkIfIndexIsValid(weekIndex)
        && (clonePhases[phaseIndex]['weeks'][weekIndex].isBulkDataAdded = true);
    checkIfIndexIsValid(phaseIndex)
        && checkIfIndexIsValid(weekIndex)
        && checkIfIndexIsValid(subjectIndex)
        && checkIfIndexIsValid(chapterIndex)
        && (clonePhases[phaseIndex]['weeks']
        [weekIndex]['subjects'][subjectIndex]['chapters']
        [chapterIndex].isBulkDataAdded = true);
    checkIfIndexIsValid(phaseIndex)
        && checkIfIndexIsValid(weekIndex)
        && checkIfIndexIsValid(subjectIndex)
        && checkIfIndexIsValid(chapterIndex)
        && checkIfIndexIsValid(conceptIndex)
        && (clonePhases[phaseIndex]['weeks']
        [weekIndex]['subjects'][subjectIndex]['chapters']
        [chapterIndex]['concepts'][conceptIndex].isBulkDataAdded = true);
    return clonePhases;
}


export const handleDeleteContentFromChapter = ({ treeData, setTreeData, contentItem, chapterPhaseData }: any) => {
    let cloneTree = JSON.parse(JSON.stringify(treeData));
    const { phases = [] } = treeData;
    const clonePhases = JSON.parse(JSON.stringify(phases));
    const { subjectIndex, weekIndex, phaseIndex, chapterIndex, conceptIndex } = chapterPhaseData;
    clonePhases[phaseIndex]['weeks'][weekIndex]
    ['subjects'][subjectIndex]['chapters'][chapterIndex]
    ['concepts'][conceptIndex]['content'] =
        clonePhases[phaseIndex]['weeks'][weekIndex]
        ['subjects'][subjectIndex]['chapters'][chapterIndex]
        ['content'].filter((ele: any) => ele.id !== contentItem.id);
    cloneTree = { ...cloneTree, phases: JSON.parse(JSON.stringify(clonePhases)) };
    setTreeData({
        treeData: cloneTree
    })
}

export const deleteDeSelectedData = (treeData: any, id: any) => {
    const { phases = [] } = treeData;
    console.log({ id });
    let clonePhases = JSON.parse(JSON.stringify(phases));
    phases.forEach((phase: any, phaseIndex: number) => {
        const { weeks = [] } = phase;
        weeks.forEach((week: any, weekIndex: number) => {
            const { subjects = [] } = week;
            subjects.forEach((subject: any, subjectIndex: number) => {
                const { chapters = [] } = subject;
                chapters.forEach((chapter: any, chapterIndex: number) => {
                    const { concepts = [] } = chapter;
                    clonePhases[phaseIndex]['weeks'][weekIndex]
                    ['subjects'][subjectIndex]['chapters'][chapterIndex]
                    ['content'] =
                        clonePhases[phaseIndex]['weeks'][weekIndex]
                        ['subjects'][subjectIndex]['chapters'][chapterIndex]
                        ['content'].filter((ele: any) => !id.includes(ele.id))
                    concepts.forEach((concept: any, conceptIndex: number) => {
                        clonePhases[phaseIndex]['weeks'][weekIndex]
                        ['subjects'][subjectIndex]['chapters'][chapterIndex]
                        ['concepts'][conceptIndex]['content'] =
                            clonePhases[phaseIndex]['weeks'][weekIndex]
                            ['subjects'][subjectIndex]['chapters'][chapterIndex]
                            ['concepts'][conceptIndex]['content'].filter((ele: any) => !id.includes(ele.id))

                    })
                })
            })
        });
    });
    console.log({ clonePhases });
    return { ...treeData, phases: JSON.parse(JSON.stringify(clonePhases)) };

}